import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { HonestTimePickerInput } from 'components/HonestTimePicker/HonestTimePickerInput'
import { Input } from 'components/Input/Input'
import { NavBar } from 'components/NavBar/NavBar'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { absenceList } from './shiftsData'
import { ISelectValue } from 'constants/globalTypes'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { BodyText, ParagraphText, TitleText } from 'styling/Typography'
import { ScheduleWeeklyCard, ShiftIconSelectBox, } from './Shifts.styled'
import { BeachIcon } from './Icons/BeachIcon'
import { DrinkIcon } from './Icons/DrinkIcon'
import { HeartIcon } from './Icons/HeartIcon'
import { RotationIcon } from './Icons/RotationIcon'
import { SunriseIcon } from './Icons/SunriseIcon'
import { SunsetIcon } from './Icons/SunsetIcon'
import { convertMinsToHrsMins } from 'utils/helpers'
import { addShift } from 'features/shifts/shiftsSlice'
import { CancelBtn } from 'components/Button/CancelBtn'
import { toast } from 'react-toastify'
import { SunIcon } from './Icons/SunIcon'

export const AddShift = () => {
    const [state, setState] = useState<IShiftState>({
        name: '',
        info: '',
        color: '#ff9900',
        absenceType: {
            value: 6,
            label: 'Active'
        },
        range: {
            shiftStart: 480,
            minutes: 540,
            minutesSelected: false,
            startSelected: false
        },
        icon: 'sunrise',
        iconColor: '#ffffff',
        textColor: '#464255'
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    const navigate = useNavigate()

    const invalid = (!state.name || !state.info || !state.absenceType?.value || (state.absenceType.value == 6 && (!state.range.minutesSelected || !state.range.startSelected)))

    const handleSave = async () => {

        if (invalid) {
            toast.warning('Please fill in all required fields')
            return
        }
        const resp = await dispatch(addShift(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(-1)
        }
    }

    const handleTimeChange = (time: string, name: string) => {
        const splitted = time.split(':')
        const minutes = parseInt(splitted[0]) * 60 + parseInt(splitted[1])
        if (name == 'shiftStart') {
            setState((prev) => {
                const copy = { ...prev }
                return { ...copy, range: { ...copy.range, shiftStart: minutes, startSelected: true } }
            })
        } else {
            setState((prev) => {
                const copy = { ...prev }
                if (minutes > copy.range.shiftStart) {
                    return { ...copy, range: { ...copy.range, minutes: minutes - copy.range.shiftStart, minutesSelected: true } }
                } else {
                    return { ...copy, range: { ...copy.range, minutes: 1440 - copy.range.shiftStart + minutes, minutesSelected: true } }
                }
            })
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setState(prev => ({ ...prev, [name]: value }))
    }

    const handleSelect = (value: ISelectValue) => {
        setState(prev => ({ ...prev, absenceType: value }))
    }


    const selectIcon = (icon: string) => {
        setState(prev => ({ ...prev, icon }))
    }

    const getIcon = () => {
        switch (state.icon) {
            case 'sunrise':
                return <SunriseIcon stroke={state.iconColor || '#ff9900'} />
            case 'sunset':
                return <SunsetIcon stroke={state.iconColor || '#ff9900'} />
            case 'rotation':
                return <RotationIcon stroke={state.iconColor || '#ff9900'} />
            case 'beach':
                return <BeachIcon stroke={state.iconColor || '#ff9900'} />
            case 'drink':
                return <DrinkIcon stroke={state.iconColor || '#ff9900'} />
            case 'sun':
                return <SunIcon stroke={state.iconColor || '#ff9900'} />
            case 'heart':
                return <HeartIcon stroke={state.iconColor || '#ff9900'} />
            default:
                return null
        }
    }

    return <>   <NavBar />
        <PageWrapper>
            <H1WithBack arrow title='Add Shift' />
            <Flex mt='16' gap='2rem'  >
                <Flex column gap='1rem' width='30%' >
                    <TitleText weight='bold' > Shift Details</TitleText>
                    <Input invalid={!state.name} placeholder='Morning shift' labelText='Name' value={state.name} onChange={handleChange} nomarg name='name' />
                    <HonestSelectInput
                        options={absenceList}
                        labelText='Type'
                        nomarg
                        onChange={handleSelect}
                        defaultValue={state.absenceType?.value}
                        invalid={!state.absenceType}
                    />
                    {state.absenceType?.value == 6 && <Flex gap='2rem' >
                        <HonestTimePickerInput
                            labelText='From'
                            onChange={(time) => handleTimeChange(time, 'shiftStart')}
                            defaultValue={state ? state.range.shiftStart : null}
                        />
                        <HonestTimePickerInput
                            labelText='To'
                            onChange={(time) => handleTimeChange(time, 'minutes')}
                            defaultValue={state ? state.range.minutes : null}
                            calculated={state.range.shiftStart}
                        />
                    </Flex>}
                    <Input height='150px' placeholder='Enter description' labelText='Shift description' value={state.info} onChange={handleChange} nomarg name='info' type='textarea' />
                </Flex>
                <Flex column gap='1rem' width='30%' style={{ borderLeft: '1px solid #8A8A8A', paddingLeft: '1rem' }} >
                    <TitleText weight='bold' > Shift Design</TitleText>
                    <Flex gap='1rem' >
                        <Input labelText='Card color' value={state.color || '#ff9900'} onChange={handleChange} nomarg name='color' type='color' />
                        <Input labelText='Icon color' value={state.iconColor || '#ff9900'} onChange={handleChange} nomarg name='iconColor' type='color' />
                        <Input labelText='Text color' value={state.textColor || '#000000'} onChange={handleChange} nomarg name='textColor' type='color' />

                    </Flex>
                    <BodyText weight='bold' >Icon</BodyText>
                    <Flex width='100%' gap='1rem' wrap >
                        <ShiftIconSelectBox onClick={() => selectIcon('sunrise')} active={state.icon == 'sunrise'} >
                            <SunriseIcon stroke={state.iconColor || '#ff9900'} />
                        </ShiftIconSelectBox>
                        <ShiftIconSelectBox onClick={() => selectIcon('sunset')} active={state.icon == 'sunset'} >
                            <SunsetIcon stroke={state.iconColor || '#ff9900'} />
                        </ShiftIconSelectBox>
                        <ShiftIconSelectBox onClick={() => selectIcon('rotation')} active={state.icon == 'rotation'} >
                            <RotationIcon stroke={state.iconColor || '#ff9900'} />
                        </ShiftIconSelectBox>
                        <ShiftIconSelectBox onClick={() => selectIcon('beach')} active={state.icon == 'beach'} >
                            <BeachIcon stroke={state.iconColor || '#ff9900'} />
                        </ShiftIconSelectBox>
                        <ShiftIconSelectBox onClick={() => selectIcon('drink')} active={state.icon == 'drink'} >
                            <DrinkIcon stroke={state.iconColor || '#ff9900'} />
                        </ShiftIconSelectBox>
                        <ShiftIconSelectBox onClick={() => selectIcon('heart')} active={state.icon == 'heart'} >
                            <HeartIcon stroke={state.iconColor || '#ff9900'} />
                        </ShiftIconSelectBox>
                        <ShiftIconSelectBox onClick={() => selectIcon('sun')} active={state.icon == 'sun'} >
                            <SunIcon stroke={state.iconColor || '#ff9900'} />
                        </ShiftIconSelectBox>
                    </Flex>
                    <BodyText weight='bold' >Card Preview</BodyText>
                    <ScheduleWeeklyCard style={{ width: '150px', height: 60, overflow: 'hidden' }} color={state.color} >
                        <Flex gap='0.5rem' center width='100%' minWidth='0' >
                            {getIcon()}
                            <Flex column minWidth='0' style={{ flex: 1, overflow: 'hidden' }} >

                                <BodyText
                                    style={{
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        maxWidth: '100%',
                                        color: state.textColor
                                    }}
                                    weight='bold' >{state.name || 'Shift name'}
                                </BodyText>
                                <ParagraphText style={{ color: state.textColor }} >
                                    {convertMinsToHrsMins(state.range.minutes)}-{convertMinsToHrsMins(state.range.minutes, state.range.shiftStart)}
                                </ParagraphText>
                            </Flex>
                        </Flex>
                    </ScheduleWeeklyCard>
                </Flex>
            </Flex>
        </PageWrapper>
        <PageFooter>
            <Flex width='100%' end='true'>
                <CancelBtn />
                <Button ml='15' height='40' orange onClick={handleSave}  >
                    Save
                </Button>
            </Flex>
        </PageFooter>
    </>
}

export interface IShiftState {
    id?: number
    name: string
    info: string
    color?: string
    absenceType: ISelectValue
    range: {
        shiftStart: number
        minutes: number
        minutesSelected: boolean
        startSelected: boolean
    }
    icon: string
    iconColor: string
    textColor: string
} 